import { api } from "..";

// Live "is this username taken?" probe used by the create-account forms on
// username-field blur. Boolean only — the server never says who owns it.
export const checkUsernameAvailability = async (
  username: string
): Promise<boolean> => {
  const res = await api.client.get<{ available: boolean }>(
    "/users-new/username-availability",
    { params: { username } }
  );
  return res.data.available;
};
